import { Link } from 'react-router-dom';
import type { Movie } from '@/types';

interface MovieCardProps {
  movie: Movie;
  showCategory?: boolean;
}

export default function MovieCard({ movie, showCategory = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block w-full"
      aria-label={`${movie.title} 详情`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200 border border-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}海报`}
          title={`${movie.title} - 影视详情 - 青苹果影院`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-2">
          {movie.isNew ? (
            <span className="px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-[11px] font-medium leading-tight">
              新上线
            </span>
          ) : (
            <span className="px-2 py-0.5 rounded-md bg-foreground-950/60 text-background-50 text-[11px] font-medium leading-tight">
              {movie.category === 'movie' ? '电影' : '剧集'}
            </span>
          )}
          {movie.isHot && (
            <span className="flex items-center gap-0.5 px-1.5 py-0.5 rounded-md bg-background-50/90 text-accent-700 text-[11px] font-medium leading-tight">
              <i className="ri-fire-line text-xs" aria-hidden="true" />
              热门
            </span>
          )}
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent p-2.5">
          <div className="flex items-end justify-between gap-2">
            <span className="text-[11px] text-background-50/85 truncate">
              {movie.region} · {movie.year}
            </span>
            <span className="flex items-center gap-0.5 shrink-0 text-accent-300 text-xs font-semibold font-label">
              <i className="ri-star-fill text-[11px]" aria-hidden="true" />
              {movie.rating.toFixed(1)}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
          {movie.title}
        </h3>
        <div className="mt-1.5 flex items-center gap-1.5 flex-wrap">
          {showCategory && (
            <span className="text-[11px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-800">
              {movie.category === 'movie' ? '电影' : '电视剧'}
            </span>
          )}
          {movie.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="text-[11px] px-1.5 py-0.5 rounded bg-background-100 text-foreground-600 border border-background-200"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}